import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import api from '@/api';
import Breadcrumbs from '@/components/Breadcrumbs';
import Page from '@/components/Page';
import PageContent from '@/components/PageContent';
import PageHeader from '@/components/PageHeader';
import PageTitle from '@/components/PageTitle';
import PageTitleLink from '@/components/PageTitleLink';
import { ROUTE_PATH } from '@/features/parkingPage/consts';
import { ROUTE_PATH as TIMIRYAZEV_ROUTE_PATH } from '@/features/timiryazevParkingPage/consts';
import {
  carFilters,
  dateFilters,
} from '@/features/valetParkingPage/consts/keys';
import { downloadXls } from '@/features/valetParkingPage/utils';

import Table from './Table';

const ValetParkingPage = props => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);

  const { location, classes } = props;

  const loadValetParkingData = async (sort, filter) => {
    setLoading(true);

    const filters = {
      page,
      size: pageSize,
    };

    try {
      const response = await api.doGetParkingRequest('/valet/sessions', {
        ...filters,
        sort,
        filter,
      });

      setData(response.content);
      setTotalCount(response.total_elements);
    } catch (e) {
      throw e;
    } finally {
      setLoading(false);
    }
  };

  const onSetPageSize = newPageSize => {
    setPage(0);
    setPageSize(newPageSize);
  };

  const onSetPage = newPage => {
    setPage(newPage);
  };

  const onSetParams = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const filter = [];
    const sort = [];

    for (const param of searchParams) {
      let filterStr = '';

      const name = param[0];
      const value = param[1];
      const filteredName = name.replace('[gte]', '').replace('[lte]', '');

      const isDate = dateFilters.includes(filteredName);

      const isCar = carFilters.includes(filteredName);

      if (name !== 'sort') {
        if (name.indexOf('gte') !== -1) {
          const fieldValue = isDate
            ? moment(new Date(value))
                .utc()
                .format(`YYYYMMDDTHHmmss`)
            : value;

          filterStr = `${filteredName}>${fieldValue}`;
        } else if (name.indexOf('lte') !== -1) {
          const fieldValue = isDate
            ? moment(new Date(value))
                .utc()
                .format(`YYYYMMDDTHHmmss`)
            : value;

          filterStr = `${filteredName}<${fieldValue}`;
        } else if (isCar) {
          filterStr = `${filteredName}~${value}`;
        } else {
          filterStr = `${filteredName}:${value}`;
        }
        filter.push(filterStr);
      } else {
        sort.push(value);
      }
    }

    return {
      sort,
      filter,
    };
  };

  const onDownloadExcel = () => {
    const { sort, filter } = onSetParams();

    downloadXls({ page, limit: pageSize, sort, filter });
  };

  useEffect(() => {
    const { sort, filter } = onSetParams();

    loadValetParkingData(sort, filter);
  }, [pageSize, page, location.search]);

  return (
    <Page>
      <PageHeader gutterBottom={false}>
        <Breadcrumbs />
        <Grid container alignItems="baseline">
          <PageTitle gutterBottom={false}>Valet</PageTitle>
          <PageTitleLink to={ROUTE_PATH}>Паркинг(SPT)</PageTitleLink>
          <PageTitleLink to={TIMIRYAZEV_ROUTE_PATH}>Тимирязева</PageTitleLink>
        </Grid>
      </PageHeader>
      <PageContent className={classes.tableBlock}>
        <div className={classes.buttonsWrapper}>
          <Button
            variant="outlined"
            color="default"
            size="small"
            className={classes.button}
            onClick={onDownloadExcel}
          >
            Вывести в EXCEL
          </Button>
        </div>
        <Table
          limit={pageSize}
          items={data}
          isLoading={loading}
          totalCount={totalCount}
          page={page}
          updatePage={onSetPage}
          updateLimit={onSetPageSize}
        />
      </PageContent>
    </Page>
  );
};

ValetParkingPage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default ValetParkingPage;
